import { useIntercom as useIntercomHook } from 'react-use-intercom'

export const useIntercom = () => {
  const { showArticle, show } = useIntercomHook()

  const showIntercomArticle = (articleId: number) => {
    try {
      showArticle(articleId)
    } catch (error) {
      console.error('Failed to show Intercom article:', error)
    }
  }

  const supportClick = () => {
    try {
      show()
      console.log('Intercom launch')
    } catch (error) {
      console.error('Failed to toggle Intercom:', error)
    }
  }

  return { showIntercomArticle, supportClick }
}
